import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { translate } from "react-i18next";
import { hot } from "react-hot-loader";

import moment from "../../lib/moment";
import View from "./View";
import ErrorBoundary from "./ErrorBoundary";
import { hydrate } from "../../store/modules/clock";

/**
 * ClockContainer
 */
class ClockContainer extends React.Component {
  static propTypes = {
    id: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    data: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    hydrate: PropTypes.func.isRequired,
    usedPostcode: PropTypes.string,
    hasFetched: PropTypes.bool.isRequired
  };
  static defaultProps = {
    id: 0,
    usedPostcode: ""
  };

  componentWillMount() {
    if (this.props.id) {
      this.props.hydrate(this.props.id, this.props.usedPostcode);
    }
  }

  componentWillReceiveProps(props) {
    if (this.props.id !== props.id) {
      this.props.hydrate(props.id, props.usedPostcode);
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <View {...this.props} {...this.props.data} />
      </ErrorBoundary>
    );
  }
}

const selectClockData = createSelector(
  [state => state.clock.get("data"), (state, props) => props.data],
  (stateData, propsData) => {
    let data = propsData;
    if (!data) {
      data = stateData;
    }
    if (!data) {
      return {};
    }
    const loadTime = data.get("time", 0) * 1000;
    const now = moment(loadTime);
    const nextDate = moment(data.get("nextPossibleDate")).set(12, "hours");
    const nextDateIsNextYear = now.format("YYYY") !== nextDate.format("YYYY");

    return {
      time: loadTime,
      realtime: data.get("realtime") ? data.get("realtime", 0) * 1000 : 0,
      isFreshProduct: data.get("nonFreshProduct", false) === false,
      isTodayPossible: data.get("nextPossibleDate") === now.set(12, "hours").format("YYYY-MM-DD"),
      hasPostcodeCheck: data.get("displayPostcodeCheck", false),
      usedPostcode: data.get("postcode"),
      isPostcodePossible: data.get("isPostcodePossible"),
      isTomorrowPossible:
        data.get("nextPossibleDate") ===
        now
          .add(1, "day")
          .set(12, "hours")
          .format("YYYY-MM-DD"),
      nextDate: nextDate.format(`dddd D MMMM ${nextDateIsNextYear ? "YYYY" : ""}`),
      nextPossibleDate: data.get("nextPossibleDate"),
      orderBeforeTime: data.get("orderBeforeTime"),
      deliveryFromTime: data.get("deliveryFromTime"),
      deliveryTillTime: data.get("deliveryTillTime")
    };
  }
);

const selectCartWebProductId = createSelector(
  [state => state.cart],
  cart => {
    if (!cart) {
      return 0;
    }
    return cart.getIn(["context", "currentItemContext", "webProductId"], 0);
  }
);

export default hot(module)(
  translate()(
    connect(
      (state, props) => ({
        data: selectClockData(state, props),
        id: props.id || selectCartWebProductId(state),
        hasFetched: state.clock.get("hasFetched", false),
        isFetching: state.clock.get("isFetching", false)
      }),
      {
        hydrate
      }
    )(ClockContainer)
  )
);
